const host = process.env.VUE_APP_BASE_URL_SERVER
const port = process.env.VUE_APP_BASE_URL_PORT

const host_oms = process.env.VUE_APP_BASE_URL_SERVER
const port_oms = process.env.VUE_APP_BASE_URL_PORT

const baseUrl = `${host}:${port}`;
const baseUrlOMS = `${host_oms}:${port_oms}`;


// DASHBOARD
const algorithms = (token) =>
  `${baseUrl}/bwfs/v2/portfolio/resume/${token}`;

const algorithm_selector_investor = (token) =>
  `${baseUrl}/bwfs/v2/algorithms/investors/${token}`;

const basic_information = () =>
  `${baseUrl}/bwfs/v2/investor/basic-information`;
const algorithm_selector = () =>
  `${baseUrl}/bwfs/v2/algorithm/selector`;

const current_positions = () => `${baseUrl}`;

const download_report = () =>
  `${baseUrl}/bwfs/v2/investor/generate_investors_report`;

const download_orders_report = () =>
  `${baseUrl}/bwfs/admin/investors/report`;

const exchange_selector = () => `${baseUrl}/bwfs/v2/exchanges`;

const exposure = () => `${baseUrl}/bwfs/v2/open_orders_summary`;

const exposure_chart = () => `${baseUrl}/bwfs/v2/get_exposure`;

const open_orders = (token) => `${baseUrl}/bwfs/v2/orders/${token}`;

const open_orders_json = () =>
  `${baseUrl}/bwfs/admin/backtest/order/json`;

const immediate_close = () => `${baseUrlOMS}/api/v3/market_order/individual`;

const performance_account = () =>
  `${baseUrl}/bwfs/v2/investor/perfomance/chart`;

const statics_fee = () => `${baseUrl}/bwfs/v2/fees`;

const statics_max_drawdown = (token) =>
  `${baseUrl}/bwfs/v2/investor/statistics_max_drawdown/${token}`;

const statics_metrics = () => `${baseUrl}/bwfs/v2/annualized_metrics`;

const statistics_nav = () => `${baseUrl}/bwfs/v2/performance`;

const crypto_slider = () => `${baseUrl}/bwfs/v2/tickers`;

const news_sliders = () => `${baseUrl}/bwfs/v2/news`;

const news_details = (token) =>
  `${baseUrl}/bwfs/v2/news/bytoken/${token}`;
//GROUPS
const fetch_groups = () => `${baseUrl}/bwfs/v2/groups/all`;

const create_group = () => `${baseUrl}/bwfs/admin/groups/create`;

const delete_group = () => `${baseUrl}/bwfs/v2/groups/delete_group`;

const edit_group = () => `${baseUrl}/bwfs/v2/groups/update`;

const group_credentials = () =>
  `${baseUrl}/bwfs/v2/groups/show_credential`;

// CONNECTIONS
const connection_list = () =>
  `${baseUrl}/bwfs/v2/exchange_connections`;

const create_connection = () =>
  `${baseUrl}/bwfs/v2/exchange_connection`;

const connection_list_selector = () =>
  `${baseUrl}/bwfs/v2/exchange_connections_resume`;

const connection_update = (token) =>
  `${baseUrl}/bwfs/v2/exchange_connection/${token}`;

const delete_connection = (token) =>
  `${baseUrl}/bwfs/v2/exchange_connection/delete/${token}`;

// PORTFOLIOS
const create_portfolio = () => `${baseUrl}/bwfs/v2/portfolio`;

const delete_portfolio = (token) =>
  `${baseUrl}/bwfs/v2/portfolio/delete/${token}`;

const portfolio_list = (token) =>
  `${baseUrl}/bwfs/v2/portfolio/investor/${token}`;

const update_portfolio = (token) =>
  `${baseUrl}/bwfs/v2/portfolio/${token}`;

// Closed orders
const closed_orders_list = (token) =>
  `${baseUrl}/bwfs/v2/orders/${token}`;

//Investors
const archive_account = () => `${baseUrl}/bwfs/admin/investor/archive`;

const create_investor = () => `${baseUrl}/bwfs/v2/investor/add`;

const create_labeling = () => `${baseUrl}/bwfs/investors/labeling`;

const delete_investor = (token) =>
  `${baseUrl}/bwfs/v2/investor/delete/${token}`;

const investors_list = () => `${baseUrl}/bwfs/v2/investors`;

const investor_info = (token) =>
  `${baseUrl}/bwfs/v2/admin/investor/information/${token}`;

const notifications_list = (token) =>
  `${baseUrl}/bwfs/v2/actions`;

const create_action = () => `${baseUrl}/bwfs/v2/actions/new`;

const delete_action = (token) => `${baseUrl}/bwfs/v2/actions/delete/${token}`;

const labeling_list = () => `${baseUrl}/bwfs/get/labeling`;

const groups_selector = () => `${baseUrl}/bwfs/admin/groups/all`;

const turn_on_off_account = () =>
  `${baseUrl}/bwfs/admin/toogle/account`;

const update_investor = (token) =>
  `${baseUrl}/bwfs/v2/investor/update/${token}`;

//ALGORITHM HEALTH
const systems_heartbeat_list = () =>
  `${baseUrl}/bwfs/v2/algorithm_instance`;

const systems_heartbeat_timeline = () =>
  `${baseUrl}/bwfs/v2/get_incidents_timeline`;

const tags_list = () =>
  `${baseUrl}/bwfs/v2/algorithm_instance/get_all_tags`;

const delete_systems_heartbeat = (token) =>
  `${baseUrl}/bwfs/v2/algorithm_instance/delete/${token}`;

const create_systems_heartbeat = () =>
  `${baseUrl}/bwfs/v2/algorithm_instance/new`;

const update_systems_heartbeat = () =>
  `${baseUrl}/bwfs/v2/algorithm_instance/update`;

const create_notification_list = () =>
  `${baseUrl}/bwfs/v2/heartbeat_notification/new`;

const delete_notification_configuration = (token) =>
  `${baseUrl}/bwfs/v2/heartbeat_notification/delete/${token}`;

const notification_configuration_list = () =>
  `${baseUrl}/bwfs/v2/heartbeat_notification`;

const update_notification_configuration = () =>
  `${baseUrl}/bwfs/v2/heartbeat_notification/update`;

// DEPOSIT AND WITHDRAWLS
const create_transaction = () => `${baseUrl}/bwfs/v2/transaction/new`;

const delete_transaction = (token) =>
  `${baseUrl}/bwfs/v2/transaction/delete/${token}`;

const transaction_list = () => `${baseUrl}/bwfs/v2/transaction`;

const update_transaction = () =>
  `${baseUrl}/bwfs/v2/transaction/modify`;

export {
  algorithm_selector,
  algorithm_selector_investor,
  archive_account,
  create_systems_heartbeat,
  create_investor,
  create_labeling,
  create_notification_list,
  create_transaction,
  basic_information,
  delete_systems_heartbeat,
  delete_investor,
  delete_notification_configuration,
  delete_transaction,
  algorithms,
  closed_orders_list,
  connection_list,
  connection_list_selector,
  connection_update,
  create_portfolio,
  create_connection,
  create_group,
  current_positions,
  delete_connection,
  delete_group,
  delete_portfolio,
  download_report,
  download_orders_report,
  edit_group,
  exchange_selector,
  exposure,
  exposure_chart,
  fetch_groups,
  group_credentials,
  investors_list,
  investor_info,
  immediate_close,
  labeling_list,
  news_details,
  news_sliders,
  notification_configuration_list,
  crypto_slider,
  open_orders,
  open_orders_json,
  performance_account,
  portfolio_list,
  statistics_nav,
  statics_fee,
  statics_max_drawdown,
  statics_metrics,
  update_portfolio,
  groups_selector,
  systems_heartbeat_list,
  systems_heartbeat_timeline,
  tags_list,
  transaction_list,
  turn_on_off_account,
  update_systems_heartbeat,
  update_investor,
  update_notification_configuration,
  update_transaction,
  notifications_list,
  create_action,
  delete_action
};
